import apiAxios from "helpers/apiAxios";

// Payment Request — cấu hình người ký cố định (admin).
const BASE = "/erp/payment_request_settings";

export const getSigners = () => apiAxios.get(BASE).then((r) => r.data);
export const updateSigners = (signers) => apiAxios.put(BASE, { signers }).then((r) => r.data);
// Payment Request options kept with the signers — e.g. { admin_act_as_accountant: true }.
export const updateSignerOptions = (options) => apiAxios.put(BASE, { options }).then((r) => r.data);
export const searchUsers = (q) => apiAxios.get(`${BASE}/users`, { params: { q } }).then((r) => r.data);

// Chữ ký số (admin): Hub-Sign + VNPT SmartCA. Secret không bao giờ được trả về —
// chỉ có { set, source }. Gửi secret rỗng = giữ nguyên giá trị cũ.
export const getDigitalSignatureConfig = () => apiAxios.get(`${BASE}/digital_signature`).then((r) => r.data);
export const updateDigitalSignatureConfig = (settings) =>
  apiAxios.put(`${BASE}/digital_signature`, { settings }).then((r) => r.data);
export const testDigitalSignature = () => apiAxios.post(`${BASE}/digital_signature/test`).then((r) => r.data);
// Certificates of one SmartCA account, read from VNPT: [{ serial_number, subject, valid_to, certificate_pem, ca_pem }]
export const lookupSmartCaCertificates = (smartcaUserId) =>
  apiAxios.post(`${BASE}/digital_signature/lookup_certificates`, { smartca_user_id: smartcaUserId }).then((r) => r.data);

// Notification rules — mỗi site → 1 Accountant nhận thông báo (sau khi Manager duyệt).
export const getSites = () => apiAxios.get(`${BASE}/sites`).then((r) => r.data);
export const getNotificationRules = () => apiAxios.get(`${BASE}/notification_rules`).then((r) => r.data);
export const updateNotificationRules = (rules) =>
  apiAxios.put(`${BASE}/notification_rules`, { rules }).then((r) => r.data);

// Payment Request → Settings → ERP dimensions (admin): dimensions AX requires per ledger
// account, checked before a journal is created. `learn` reads AX's own message.
export const getDimensionRules = () => apiAxios.get(`${BASE}/dimension_rules`).then((r) => r.data);
export const saveDimensionRules = (rules) => apiAxios.put(`${BASE}/dimension_rules`, { rules }).then((r) => r.data);
export const learnDimensionRules = (text) => apiAxios.post(`${BASE}/dimension_rules/learn`, { text }).then((r) => r.data);

// Payment Request → Settings → HSBC (admin): one form — connection, HSBC API
// credential, Pebsteel as payer, per-payment defaults. Secrets are never returned:
// only whether each is configured. A blank secret box keeps its stored value.
const KEYS = "/erp/hsbc_keys";

export const getHsbcSettings = () => apiAxios.get(`${KEYS}/settings`).then((r) => r.data);
export const saveHsbcSettings = (settings) => apiAxios.put(`${KEYS}/settings`, { settings }).then((r) => r.data);

// Gateway PGP keys (admin), forwarded to gpg-encrypt /api/admin/keys. The Portal does
// not keep the key file; a new key takes effect after the gateway restarts.
export const getHsbcKeys = () => apiAxios.get(KEYS).then((r) => r.data);
export const uploadHsbcKey = ({ key, armored, expectedFingerprint }) =>
  apiAxios.post(KEYS, { key, armored, expected_fingerprint: expectedFingerprint }).then((r) => r.data);
